import styled from 'styled-components';

export const Wrapper = styled.div`
    .asset-container {
        padding: 3rem 2rem 2rem 2rem;
        position: relative;
    }
    .filter-header {
        display: flex;
        justify-content: space-between;
        padding: 0rem 1rem;
        margin-bottom: 1rem;
    }
    .coin-symbol-wrapper {
        display: flex;
        align-items: center;
        .coin-wrap {
            margin-right: 5px;
        }
        .config-content {
            display: flex;
            align-items: center;
            margin-left: 5px;
        }
    }
    .coin-symbol-wrapper:hover {
        cursor: pointer;
        .selected-asset {
            text-decoration: underline;
        }
    }
    .balance-column {
        width: 18rem;
    }
    .status-verified {
        margin: 5px 5px 0px 0px;
        font-size: 15px;
        color: #707070;
    }
    .plan-img{
        width: 2rem;
        height: 2rem;
        padding-right: 5px;
    }
    .text-link {
        color: #3A4FFF !important;
    }
    .link {
        color: #0000FF;
        cursor: pointer;
        text-decoration: underline;
    }
    .title {
        font-family: HaasGrotDisp;
        font-size: 24px;
        font-weight: bold;
    }
    .sub-title {
        font-family: HaasGrotDisp;
        font-size: 15px;
        font-weight: bold;
        margin-top: 5px;
    }
    .preview-container {
        width: 30rem;

        .preview-detail-container {
            width: 100%;
        }
    }
    .preview-coin-container {
        display: flex;
        margin: 2rem 0rem;

        .preview-content {
            flex: 1;
            align-items: center;
            justify-content: center;
            display: flex;

            .preview-color-tip {
                position: relative;
                right: 35px;

                .line {
                    position: absolute;
                    border-top: 1px solid #000;
                    width: 35px;
                    top: 12px;
                    margin-left: 3px;
                }
            }
            .preview-symbol-tip {
                position: relative;
                left: 35px;
                bottom: 22px;

                .line {
                    position: absolute;
                    border-top: 1px solid #000;
                    width: 50px;
                    top: 12px;
                    right: 50px;
                    margin-right: 3px;
                }
            }
            .preview-name-tip {
                position: relative;
                top: 8px;
                right: 8px;

                .line {
                    position: absolute;
                    border-top: 1px solid #000;
                    width: 60px;
                    top: 12px;
                    right: 40px;
                    margin-right: 3px;
                }
            }
            .preview-icon-tip {
                position: relative;
                left: 30px;

                .line {
                    position: absolute;
                    border-top: 1px solid #000;
                    width: 35px;
                    top: 12px;
                    right: 30px;
                    margin-right: 3px;
                }
            }
        }
        .icon-preview {
            width: 94px;
            height: 94px;
        }
        .new-asset-icon {
            width: 3rem;
        }
    }
    .preview-detail-container {
        color: #ffffff;
        /* border-top: 1px solid #A8A8B1; */
        /* padding: 1rem; */
        background-color: #212121;
        padding: 2rem 3rem;
        margin-bottom:2rem;
        width: 65%;
    }
    .type-wrap {
        display: flex;
        position: relative;
        .warning-container {
            position: relative;
        }
        .warning {
            position: absolute;
            left: 100%;
            bottom: 0px;
        }
    }
    .overview-wrap {
        display: flex;
        justify-content: space-between;
        // margin-top: 1rem;
        .configure-btn {
            font-size: 32px;
            height: auto;
        }
        .preview-container {
            .preview-content {
                flex-direction: column;
                .edit-content {
                    margin-top: 0.25rem;
                    color: #ffffff;
                }
            }
            .description-small {
                font-size: 10px;
                margin-top: 0.25rem;
                text-align: center;
                width: 70%;
                color: #fff;
            }
            .remove {
                color: #ff4d4f;
                text-align: left;
                width: 60%;
            }
            .ant-breadcrumb-link {
			color: #A8A8B1;
            a {
                color: #fff ;
                    text-decoration: none;
                }
                a:hover {
                    color: #ffffff;
                }
		    }
        }
        .file-container {
            border-radius: 4px;
            display: block;
            padding: 0.25rem;
            white-space: nowrap;
            position: relative;
            width: 105px;

            label {
                display: block;
                padding-bottom: 0;
                box-sizing: border-box;
                .anchor {
                    color: #3A4FFF;
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
            .ant-form-item-control {
                line-height: 1;
            }
            input {
                opacity: 0;
                position: fixed;
                left: -999px;
            }
        }
        .icon-upload {
            .file-container {
                border: 0px;
                width: 105px;

                label {
                    cursor: pointer;
                }
                .upload-box {
                    background-color: #0000FF;
                    border-color: #0000FF;
                    color: #ffffff;
                    font-size: 14px;
                    font-weight: bold;
                    padding: 6px;
                    text-align: center;
                }
            }
        }
    }
    .btn-wrapper {
        display: flex;
        align-items: center;
        margin-top: 1rem;
        .separator {
            margin-left: 1rem;
        }
        .apply-btn {
            width: 100%;
        }
    }
    @media (max-width: 960px) {
        .asset-container {
            padding: 0.5rem;
            .filter-header {
                flex-direction: column;
                .create-asset-btn {
                    margin-top: 1rem;
                    width: 265px;
                }
            }
            .table-wrapper {
                overflow-x: scroll;
            }
            .ant-select,
            .ant-input {
                width: 100% !important;
            }
        }
        .overview-wrap {
            flex-direction: column-reverse;
            .configure-btn {
                font-size: 20px;
            }
        }
        .preview-container {
            width: 100%;
        }
    }
    @media (max-width:425px) {
        .asset-container {
            .filter-header {
                Button {
                    width: 100% !important;
                }
            }
            .ant-pagination-item {
                min-width: 30px;
                height: 30px;
            }
            .btn-wrapper {
                flex-direction:column;
                align-items: flex-start;
                .remove {
                    width: 100%;
                }
            }
        }
    }
`;

export const ConfigContainer = styled.div`
    .filter-title {
        font-size: 14px;
        margin-left: 1rem;
        color: #ffffff;
    }
    .table-container {
        margin-top: 2rem;
        .title {
            font-weight: bold;
            margin-bottom: 0.5rem;
        }
        .table-content {
            color: #A8A8B1;
        }
        .ant-table-thead > tr > th {
            padding: 0rem 1rem;
            background: #F2F2F2;
            border-top: 1px solid #A8A8B1;
        }
        .filter-wrapper {
            display: flex;
            justify-content: space-between;
        }
        .filter {
            padding-bottom: 30px;
        }
        .download-btn {
            width: 100px;
            border-color: #0000FF;
        }
        .ant-table-row-expand-icon {
            color: #2930ff;
            border-color: #2930ff;
        }
        .id-wrapper {
            background-color: #0000FF;
            width: 35px;
            height: 25px;
            padding: 4px;
            font-size: 12px;
            color: #fff;
        }
    }

    @media (max-width: 960px) {
        .filter-header {
            flex-direction: column;
            .create-asset-btn {
                margin-top: 1rem;
                width: 265px;
            }
        }
        .table-wrapper {
            overflow-x: scroll;
        }
    }
`
export const FeesContainer = styled.div`
    padding: 2rem 0;
    &.modal-wrapper {
        padding: 0 0;
        color: #ffffff;

        .modal-header {
            font-size: 24px;
            display: flex;
            align-items: center;

            .dollar-icon {
                margin-right: 5px;
                position: unset;
            }
        }
        .description-content {
            margin: 1rem 0rem;
        }
        .description-header {
            position: relative;
            bottom: 1.25rem;
            background-color: #000;
            padding: 0px 5px;
        }
        .description-box {
            border: 1px solid #707070;
            display: flex;
            flex-direction: column;
            padding: 0.5rem 1.5rem;
            margin: 1rem 0rem;
        }
    }
    .earnings-container {
        color: #fff;
    }
    .header {
        color: #fff;
        font-size: 16px;
        font-weight: bold;
    }
    .cloud-icon-wrapper {
        display: flex;
        position: relative;
    }
    .cloud-icon {
        height: 4rem;
        width: 4rem;
    }
    .dollar-icon {
        background-color: #008A00;
        border-radius: 50%;
        color: #000;
        font-weight: bold;
        height: 1.5rem;
        width: 1.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        position: absolute;
        top: 0px;
        left: 3rem;
    }
    .captitalize {
        text-transform: capitalize;
    }
    .memeber-status {
        color: #5D5D5D;
        font-size: 14px;
    }
    .exchange-status-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 15px 0px;
        width: 10rem;

        .settle-btn {
            margin: 10px 0px;
            width: 100%;
        }
    }
    .btn-wrapper {
        display: flex;
        margin-bottom: 1rem;
        .back-btn {
            margin-right: 5px;
            width: 100%;
        }
        .next-btn {
            margin-left: 5px;
            width: 100%;
        }
    }
    .custom {
        .quick-fees {
            color: #000;
            margin-left: 8rem;
        }
        .all-fees {
            color: #000;
        }
        .ant-tabs-bar {
            border-bottom: 1px solid #6C6C6C;
        }
        .ant-tabs-ink-bar {
            top: 39px;
        }
   }
   .link {
        color: #3A4FFF;
        cursor: pointer;
        text-decoration: underline;
    }
   .full-width {
        flex: 1;
    }
   .hr-line {
        width: 100%;
        border: 1px solid #6C6C6C;
    }
    .calculate-container {
        width: 55%;
        margin-top: 0.5rem;
        color: #000;
        .title {
            font-size: 16px;
            font-weight: bold; 
        }
        .content {
            font-size: 14px;
        }
        .field-container {
            width: 170%;
            margin-top: 2rem;
            display: flex;
            justify-content: space-between;
            .card-wrapper {
                margin-left: 5rem;
            }
            .card-head {
                font-size: 15.58px;
                &.bold {
                    font-weight: bold;
                }
                &.normal {
                    font-weight: normal;
                }
            }
            .ant-card-body {
                p {
                    color: #000;
                    margin-bottom: 0px;
                }
            }
            .secondary-container {
                width: 50%;
                .ant-btn {
                    width: 160px;
                    margin-top: 2rem;
                }
                .fields-wrapper {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    width: 25rem;
                    .ant-calendar-picker-icon {
                        display: none;
                    }
                    .ant-calendar-picker {
                        width: 160px;
                    }
                    .ant-input {
                        width: 160px;
                        border-radius: 0px;
                        border: 1px solid #A8A8B1;
                    }
                    .user-id {
                        margin-top: 2rem;
                    }
                }
            }
        }
    }
    @media (max-width: 960px) {
        .table-wrapper {
            overflow-x: scroll;
        }
    }
`
export const TransferWrapper = styled.div`
    padding: 1rem;
    color: #fff;
    .ant-input {
        width: 310px;
        height: 30px;
        border: 2px solid #C4C4C4;
        border-radius: 0px;
    }
    .ant-input-number {
        width: 310px;
        height: 30px;
        border-radius: 0px;
        border: 2px solid #C4C4C4;
    }
    .ant-form {
        margin-top: 1.5rem;
    }
    .ant-form-item-control {
        line-height: 15px;
    }
    h3 {
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 0.3em;
    }
    .ant-btn {
        width: 310px;
        height: 45px;
        margin-top: 1.5rem;
    }
    .ant-select-selection {
        border-radius: 0px;
        border: 2px solid #C4C4C4;
    }
    .ant-select-selection--single {
        height: 49px;
    }
    .ant-select-selection__rendered {
        margin-left: 8px;
    }
    .ant-select {
        width: 310px;
        height: 30px;
    }
    .user-search-field {
        height: auto;
        .ant-select-selection--single {
            height: auto;
        }
    }
    .amount-wrapper {
        margin-top: 1.5rem;
    }
    .textarea {
        .ant-input {
            width: 310px;
            height: 60px;
            border: 2px solid #C4C4C4;
            border-radius: 0px;
        }
    }
    .margin {
        margin-top: 2rem;
    }
    .type_wrapper{
        .ant-select-selection--single {
            height: 30px;
            margin-bottom: 1rem;
        }
    }
    @media (max-width: 960px) {
        .ant-select,
        .ant-input,
        .ant-input-number,
        .ant-btn {
            width: 100% !important;
        }
    }
    @media (max-width: 1060px) {
        .ant-select,
        .ant-input,
        .ant-input-number,
        .ant-btn {
            width: 310px;
        }
    }
`